import cloneDeep from "lodash.clonedeep";
import { getUserData } from "../../../services/API";

export function getCutscoresArray(statePercentileCuts) {
  const {cutscores} = statePercentileCuts;
  const entries = Object.entries(cutscores);
  entries.sort((a, b) => a[1] - b[1]);
  return entries.map(entry => ({color: entry[0].toUpperCase(), percentile: entry[1]}));
}

export function getCutscorePercentiles(statePercentileCuts) {
  if (statePercentileCuts) {
    const cutscores = getCutscoresArray(statePercentileCuts);
    return cutscores.map(cut => cut.percentile).filter(perc => perc !== 0);
  }
  return [25, 50, 75];
}

const categories = {
  GREAT: "GREAT",
  GOOD: "GOOD",
  AVERAGE: "AVERAGE",
  POOR: "POOR",
  NULL: "NULL",
}

export function getPercentileCategory(pr, percentiles) {
  if (!pr && pr !== 0) return categories.NULL;
  if (pr < percentiles[0]) return categories.POOR;
  if (pr < percentiles[1]) return categories.AVERAGE;
  if (pr < percentiles[2]) return categories.GOOD;
  return categories.GREAT;
}

export const hexCodes = {
  RED: '#FF7A7A',
  YELLOW: '#FFCC33',
  GREEN: '#66CC99',
  BLUE: '#338CCC',
  GRAY: '#A9AEB7',
  LIGHT_GRAY: '#E5E3E1',
}

export const colors = {
  GREAT: hexCodes.GREEN,
  GOOD: hexCodes.YELLOW,
  AVERAGE: hexCodes.YELLOW,
  POOR: hexCodes.RED,
  DEFAULT: hexCodes.GRAY,
  NULL: hexCodes.LIGHT_GRAY,
}

export function getCutscoreColors(statePercentileCuts) {
  const adjustedColors = cloneDeep(colors);
  if (statePercentileCuts) {
    const cutscores = getCutscoresArray(statePercentileCuts);
    const colors = cutscores.map(cut => cut.color);
    adjustedColors.POOR = hexCodes[colors[0]];
    adjustedColors.AVERAGE = hexCodes[colors[1]];
    adjustedColors.GOOD = hexCodes[colors[2]];
    adjustedColors.GREAT = hexCodes[colors[3]];
  } else {
    const { fourCutlineCategoriesEnabled } = getUserData();
    if (fourCutlineCategoriesEnabled) {
      adjustedColors.GREAT = hexCodes.BLUE;
      adjustedColors.GOOD = hexCodes.GREEN;
    }
  }
  return adjustedColors;
}

export function isUsingFourCategories(statePercentileCuts) {
  const { fourCutlineCategoriesEnabled } = getUserData();
  return (statePercentileCuts || fourCutlineCategoriesEnabled) ? true : false;
}

export const categoryLabel = {
  GREAT: "common:at_above",
  GOOD: "common:on_track",
  AVERAGE: "common:developing",
  POOR: "common:behind",
}

function getCategoryLabels(statePercentileCuts) {
  const labels = cloneDeep(categoryLabel);
  if (!isUsingFourCategories(statePercentileCuts)) {
    labels.AVERAGE = "common:on_track";
    labels.POOR = "common:catch_up";
  }
  return labels;
}

export function getPercentileInfo(pr, statePercentileCuts) {
  const percentiles = getCutscorePercentiles(statePercentileCuts);
  const category = getPercentileCategory(pr, percentiles);
  const colors = getCutscoreColors(statePercentileCuts);
  const labels = getCategoryLabels(statePercentileCuts);
  return {
    category,
    color: colors[category],
    label: labels[category],
  };
}